import { useState, useEffect } from 'react';
import Post from './PortofolioPost'
import './style/content.css';

function Portofolio(){

    const Kategori = (["All","Company Profile","Personal", "Business"])
    const [pilihKategori, setPilihKategori] = useState('All');
    
    const handleClick = (id) => {
        setPilihKategori(id)
    }

    // const handleClick = (id) => {
    //     setKategori(Kategori.map((value, i) => {
    //         if (id === i){
    //         return {...value, active: value.active = true };
    //         } else { return {...value, active: value.active = false }}            
    //     }))
    // }

    return (
        <div id='portofolio'>
            <div className='container px-5'>
                <div className='row'>
                    <div className='col text-center'>
                        <h2>Portofolio Kami</h2>
                    </div>
                </div>
                <div className='row mt-3 text-center'>
                    <div className='col'>
                        <ul className='portofolio-section m-auto d-block overflow-auto'>                          
                            {Kategori.map((data,id) => (
                                <li 
                                className={`kategori-portofolio btn me-3 mb-3 ${pilihKategori == data ? 'active-portofolio' : ''} `}
                                key={data} 
                                type="button"
                                onClick={() => {handleClick(data)}}>
                                    {data}
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
                <div className='row portofolio-cards mt-4 m-auto'>
                    <Post kategori={pilihKategori} />
                </div>
            </div>
        </div>
    )
}

export default Portofolio;